export default __webpack_public_path__ + "static/favicon-d40870538487d4aa605fb009a9b5a56a.ico";